var exports = {
  "Tc": "ChannelUserTag.module__tag___QWJnZl",
  "Dm": "ChannelUserTag.module__tagSm___QWJnZl",
  "ST": "ChannelUserTag.module__tagLg___QWJnZl",
  "Qq": "ChannelUserTag.module__text___QWJnZl",
  "WV": "ChannelUserTag.module__textSm___QWJnZl",
  "j": "ChannelUserTag.module__textLg___QWJnZl",
  "B": "ChannelUserTag.module__assetTag___QWJnZl",
  "ot": "ChannelUserTag.module__assetImage___QWJnZl",
  "lV": "ChannelUserTag.module__accessibleLabel___QWJnZl",
};

module.exports = exports;
